// 后端返回角色的菜单权限结构为
// [
//   {
//     menuId: 1,
//     menuName: 'xxx',
//     childMenus: [], // 只有一级，没有二级
//   },
//   {
//     menuId: 2,
//     menuName: 'xxx',
//     childMenus: [
//       {
//         menuId: 3,
//         menuName: 'xxx',
//         childMenus: [], // 只有一级和二级，没有三级
//       },
//     ],
//   },
//   {
//     menuId: 4,
//     menuName: 'xxx',
//     childMenus: [
//       {
//         menuId: 5,
//         menuName: 'xxx',
//         childMenus: [
//           // 有一二三级
//           {
//             menuId: 6,
//             menuName: 'xxx',
//           },
//         ],
//       },
//     ],
//   },
// ];

export default [
  {
    name: '首页',
    icon: 'tripwise-manage icon-shouye',
    url: '/index',
    type: 'menu',
    menuId: 1,
  },
  {
    name: '差旅预订',
    icon: 'tripwise-manage icon-yuding',
    url: '/TravelBooking',
    type: 'menu',
    menuId: 2,
  },
  {
    name: '架构管理',
    icon: '',
    url: '',
    type: 'module',
    menuId: 4,
    menus: [
      {
        name: '组织管理',
        icon: 'tripwise-manage icon-renyuan',
        url: '',
        type: 'menu',
        menuId: 3,
        menus: [
          {
            name: '组织架构',
            icon: '',
            url: '/manage/#/organizationManage/0',
            type: 'menu',
            routerType: 'micro-app',
            menuId: 19,
            pId: 3,
          },
        ],
      },
      {
        name: '流程管理',
        icon: 'tripwise-manage icon-resources_fill',
        url: '/manage/#/newManage/approvalSetting',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 20,
      },
      {
        name: '子母公司',
        icon: 'tripwise-manage icon-part_fill',
        url: '',
        type: 'menu',
        menuId: 32,
        menus: [
          {
            name: '集团架构',
            url: '/settlement/#/parent-company',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 67,
            tagId: 33,
          },
          {
            name: '开票设置',
            icon: '',
            url: '/settlement/#/invoice-settings',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 66,
            pId: 32,
          },
        ],
      },
      {
        name: '权限管理',
        icon: 'tripwise-manage icon-quanxian',
        url: '',
        type: 'menu',
        menuId: 5,
        menus: [
          {
            name: '功能权限',
            icon: '',
            url: '/PermissionManagement',
            type: 'menu',
            menuId: 89,
            pId: 5,
          },
          {
            name: '数据权限',
            icon: '',
            url: '/DataPermissionManagement',
            type: 'menu',
            menuId: 88,
            pId: 5,
          },
        ],
      },
    ],
  },
  {
    name: '差旅管控',
    icon: '',
    url: '',
    type: 'module',
    menuId: 33,
    menus: [
      {
        name: '差标管理',
        icon: 'tripwise-manage icon-danju01',
        url: '/manage/#/newManage/travelStandardManage',
        type: 'menu',
        routerType: 'micro-app',
        menuId: 24,
        pId: 4,
      },
      {
        name: '商务卡',
        icon: 'tripwise-manage icon-bankcard_fill',
        url: '/tripay/#/newManage/bussinessCard',
        type: 'menu',
        routerType: 'micro-app',
        menuId: 25,
        pId: 4,
        tagId: 121,
      },
      {
        name: '预算管理',
        icon: 'tripwise-manage icon-jinbi02',
        url: '/manage/#/newManage/budgetManage',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 10,
        tagId: 33,
      },
      {
        name: '节省奖励',
        icon: 'tripwise-manage icon-redpocket',
        url: '/reward-travel',
        type: 'menu',
        menuId: 86,
        pId: 4,
      },
      {
        name: '私车公用',
        icon: 'tripwise-manage icon-carctob_fill',
        url: '/scgy/#/privateCarSharingRules',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 74,
      },
      {
        name: '因私用车白名单',
        icon: 'tripwise-manage icon-car_fill',
        url: '/private-car-white-list',
        type: 'menu',
        menuId: 96,
        pId: 4,
      },
    ],
  },
  {
    name: '结算对账',
    icon: '',
    url: '',
    type: 'module',
    menuId: 68,
    menus: [
      {
        name: '结算管理',
        icon: 'tripwise-manage icon-repay_fill',
        url: '',
        type: 'menu',
        menuId: 8,
        menus: [
          {
            name: '账单管理',
            icon: '',
            url: '/settlement/#/bill',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 64,
            pId: 8,
          },
          {
            name: '发票历史',
            icon: '',
            url: '/settlement/#/invoice-history',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 80,
            pId: 8,
          },
          {
            name: '结算规则',
            icon: '',
            url: '/settlement/#/rules',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 81,
            pId: 8,
          },
        ],
      },
    ],
  },
  {
    name: '核算管理',
    icon: '',
    url: '',
    type: 'module',
    menuId: 69,
    menus: [
      {
        name: '费用管理',
        icon: 'tripwise-manage icon-danju04',
        url: '',
        type: 'menu',
        menuId: 11,
        menus: [
          {
            name: '单据管理',
            icon: '',
            url: '/manage/#/newManage/documentManage',
            type: 'menu',
            routerType: 'micro-app',
            menuId: 42,
            pId: 11,
            tagId: 131,
          },
          {
            name: '基础信息',
            icon: '',
            url: '/manage/#/newManage/basicInfo',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 41,
            pId: 11,
            tagId: 131,
          },
        ],
      },
      {
        name: '差旅补贴',
        icon: 'tripwise-manage icon-jinbi01',
        url: '/manage/#/newManage/travelSubsidyManage',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 9,
      },
      {
        name: '里程补贴',
        icon: 'tripwise-manage icon-carctob_fill',
        url: '/scgy/#/allowanceList',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 75,
      },
      {
        name: '财务映射',
        icon: 'tripwise-manage icon-ka',
        url: '/financeMapping',
        type: 'menu',
        menuId: 12,
        menus: [
          {
            name: '映射管理',
            icon: '',
            url: '/finance/#/newManage/mapManage',
            type: 'menu',
            routerType: 'micro-app',
            menuId: 51,
            pId: 12,
          },
          {
            name: '凭证管理',
            icon: '',
            url: '/finance/#/newManage/certificateManage',
            type: 'menu',
            routerType: 'micro-app',
            menuId: 52,
            pId: 12,
          },
        ],
      },
      {
        name: '合规管理',
        icon: 'tripwise-manage icon-rule_fill',
        url: '/ComplianceManagement',
        type: 'menu',
        menuId: 97,
      },
    ],
  },
  {
    name: '差旅服务',
    icon: '',
    url: '',
    type: 'module',
    menuId: 70,
    menus: [
      {
        name: '服务管理',
        icon: 'tripwise-manage icon-basicdata_fill',
        url: '',
        type: 'menu',
        menuId: 73,
        menus: [
          {
            name: '服务开通',
            icon: 'tripwise-manage icon-part_fill',
            url: '/activateService',
            type: 'menu',
            menuId: 100,
          },
          {
            name: '托管服务',
            icon: 'tripwise-manage icon-bao',
            url: '/SupplierManagement',
            type: 'menu',
            menuId: 6,
          },
          {
            name: '企业权益',
            icon: 'tripwise-manage icon-fuli',
            url: '/manage/#/newManage/companyWelfare',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 15,
          },
          {
            name: '合作信息',
            icon: 'tripwise-manage icon-fangwu',
            url: '/manage/#/newManage/cooperationInfo',
            routerType: 'micro-app',
            type: 'menu',
            menuId: 14,
          },
        ],
      },
    ],
  },
];
